<template>
  <div class="template-project" v-loading="loading">
    <div class="header" v-if="banner && banner.length > 0">
      <span @click="bannerBack(banner[0].value)">{{banner[0].label}}{{banner[1] ? '/' : ''}}</span>
      <span v-if="banner[1]">{{banner[1].label}}</span>
    </div>
    <div class="content">
      <div class="cell"  @click="add" v-if="dataset && dataset.length > 0">
        <div class="cell-created">
          <i class="icon iconfont iconicon_enlarge"></i>
          <span>新建项目模版</span>
        </div>
      </div>
      <div class="cell" v-for="item in dataset" :key="item.id" @click="detail(item)">
          <div class="img-box">
            <img :src="'image/color/img_blue.png'" alt="">
            <toolTip class="content-img-tip" style="width: 80%;text-align: center;" :title="item.template_name">{{item.template_name}}</toolTip>
          </div>
          <div class="text">
            <toolTip style="width: 0;flex: 1;" :title="item.template_name">
              <span>{{item.template_name}}</span>
            </toolTip>
            <span class="icons">
              <i class="icon iconfont iconicon_input activeIconHover edit"></i>
              <i class="icon iconfont iconicon_recycle_bin activeIconHover del" @click.stop="del(item)"></i>
            </span>
          </div>
      </div>
    </div>
    <nothing v-if="dataset && dataset.length === 0" :config="{btnText: '新建项目模板',tip:'暂无项目模板，快去添加'}" @button-click="add"></nothing>
    <AddDialog v-model="addDialogVisible" v-if="addDialogVisible" @success="addSuccess"></AddDialog>
  </div>
</template>
<script>
import AddDialog from './add'
import api from '@/services/api/template'
import { Storage } from "@/utils/utils";
export default {
  components: {
    AddDialog
  },
  data() {
    return {
      addDialogVisible: false,
      dataset: [],
      banner: [],

    }
  },
  created() {
    this.init()
    this.hetHead()
  },
  methods: {
    add() {
      this.addDialogVisible = true
    },
    addSuccess() {
      this.addDialogVisible = false
      this.init()
    },
    async init() {
      this.loading = true
      let result = await api.projectTemplatesIndex({page: 1, per_page: 999})
      this.dataset = result.data
      this.loading = false
    },
    hetHead() {
      let arr = Storage.getSession('tagList')
      this.banner = arr.slice(-2)
    },
    bannerBack(str) {
      this.$router.push(str)
    },
    async del(val) {
      await this.$wfAlert('warning', '模板删除后不可恢复,是否删除?', '', '删除', 'warning', false)
      await api.projectTemplatesSaveDelete({id: val.id})
      this.$message({
        message: '删除模板成功',
        type: 'success'
      })
      this.init()
    },
    detail(val) {
      this.$router.push(`/templateProjectDetail?id=${val.id}`)
    },
  },
}
</script>
<style lang="scss">
  .template-project {
    .content {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      padding: 0 32px;
    }
    .cell {
      width: 280px;
      height: 126px;
      display: flex;
      flex-direction: column;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid rgba(32,32,32,0.0826);;
      cursor: pointer;
      .img-box {
        height: 86px;
        flex-shrink: 0;
        position: relative;
      }
      .content-img-tip {
        padding: 0 16px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 28px;
        color: #fff;
      }
      .text {
        height: 0;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px;
        font-size: 14px;
      }
      .icons {
        visibility: hidden;
        flex-shrink: 0;
        .del {
          color: #FF3939;
          margin-left: 8px;
        }
      }
      &:hover {
        box-shadow: 0px 4px 16px 0px rgba(32,32,32,0.1552);
        .icons {
          visibility: visible;
        }
      }
      .cell-created {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-size: 14px;
        height: 100%;
        i {
          font-size: 20px;
          margin-bottom: 18px;
        }
      }
    }
    .header {
      font-size: 16px;
      font-weight: 500;
      height: 78px;
      padding: 0 32px;
      display: flex;
      align-items: center;
      color: initial;
      span:first-child {
        color: rgba(32, 32, 32, 0.6);
        cursor: pointer;
        margin-right: 8px;
        &:hover {
          color: initial;
        }
      }
    }
  }
</style>
